import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-order-ticket-preview-dialog',
  templateUrl: './order-ticket-preview-dialog.component.html',
  styleUrls: ['./order-ticket-preview-dialog.component.scss']
})
export class OrderTicketPreviewDialogComponent implements OnInit {

  ticketPreview;

  constructor(public dialogRef: MatDialogRef<OrderTicketPreviewDialogComponent>,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data) {
      this.ticketPreview = this.sanitizer.bypassSecurityTrustResourceUrl(data.ticketPreview);
    }

  ngOnInit() {
  }

}
